import React,{useEffect,useContext} from 'react'
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import SiteSeo from '../../../components/components/seo/SiteSeo'
import { useTranslation } from 'next-i18next'
import *  as data from '../../../next.config.js'
import buildQueryForKeywordsFunction from '../../api/cms/keywords/buildQueryForKeywordsFunction'
import KeyWordsData from '../../../components/components/KeyWords/KeyWords'
import NotFound from '../../../components/components/NotFound';
// import getEntityDetailsFunction from "../../api/registeration/entityDetails/getEntityDetailsFunction";
import entityMajorsFunction from "../../api/registeration/entityMajors/entityMajorsFunction";
import getAddressDetailsFunction from "../../api/registeration/addressDetails/getAddressDetailsFunction";
import WhiteMedical from '../../../components/components/Medical/WhiteMedical'
import getBlogFunction from "../../api/cms/blog/getBlogFunction";
import WhiteMedicalDetails from "../../../components/components/DetailsMedical/White";
import Statistics from "../../../components/components/Statistics";
import {getCookieCountry} from '../../api/helpers/HeaderRequest'
// import getIncludeStatusIdsFromBack from '../../api/globals/terms/getIncludeStatusIdsFromBack'
import { getvocabTermsObj } from "../../api/globals/terms/helpers";
import {getEntityDetailsFromCache} from '../../api/registeration/entityDetails/helper'
import TermsContext from "../../../context/Trems"
import { useRouter } from "next/router";
import {buidlObject} from '../../../components/helpers/helpers'
function code({ pid, entityDetails, slug, majors, address, blog, keyWords,params,statusIds,days,entityCategories,locale}) {
  const vocabTerms = useContext(TermsContext)


  const {t}=useTranslation("common")

let meta = [
    {
      name: "description",
      content:t("searchPageMetaDescription"),
    }
  ]
 

  

 
  const hakeemMedicalCodes=vocabTerms.entityTypes.filter(ele=>ele.field3==1).map(r=>r.code)
  let StatusIds = vocabTerms.statusIds;
  const foodLst=entityCategories.filter(ele=>ele.field3!=null&&buidlObject(ele.field3)&&buidlObject(ele.field3).displayInSearch=="true"&&ele.fieldConfig&&buidlObject(ele.fieldConfig).category=="food"&&StatusIds.includes(ele.statusId)&&ele.language.code==locale).map(ele=>ele.code)
  let codeLst=foodLst.concat(hakeemMedicalCodes)
    return (
        <div>  

              <KeyWordsData keyWords={JSON.parse(keyWords)}/>
              <SiteSeo title={t("mainMedicalTitle")}/>
              {(()=>{
                if(codeLst.filter(x => x==params.entityType).length>0){
                  return <div>
                  <div style={{display:"none"}}>
                      <p>{t("hakeemProfileMeta1")}</p>  
                      <p>{t("hakeemProfileMeta2")}</p>
                  </div>
                  <SiteSeo title={t("mainMedicalTitle")} meta={meta}/>
                  <KeyWordsData keyWords={JSON.parse(keyWords)}/>
                  <WhiteMedical  statusIds={vocabTerms.statusIds} days={days} isInSearchPage={true} foodSearchLst={foodLst} medicalEntityTypeLst={hakeemMedicalCodes}/>
                </div>
            } 
  else if(entityDetails){
    return <>
    
    <KeyWordsData keyWords={JSON.parse(keyWords)} />
    <Statistics entityId={params.entityType}  statisticsCode={"entity-details"}/>
    <WhiteMedicalDetails
      entityId={params.entityType}
      pid={[JSON.parse(entityDetails)[0].entityType[0].code,params.entityType]}
      entityDetails={entityDetails}
      majors={majors}
      address={address && JSON.parse(address)}
      blog={blog && JSON.parse(blog)}
      StatusIds={vocabTerms.statusIds}
      days={days}
      />
    </>

  }

  else{
    return <NotFound/>
  }
})()}
            
        </div>
    )
}


export default code
export async function getServerSideProps({ params, locale, req }) {
  let country = getCookieCountry(req) != null ?getCookieCountry(req).userCountry:null 

  let SearchData = {
    lang: locale,
    limit: 1000,
    userCountryCode:country
  };
  let id = null;
  let response = null
  let getMajors=null
  let getAddress =null
  let blogTypes =null
  let getBlog =null
  id=params.entityType
  SearchData.id=[params.entityType]
  let dataOfQuery={}
  if(parseInt(params.entityType)){

     response = await getEntityDetailsFromCache(SearchData, req);
     getMajors = await entityMajorsFunction(
      { entityId: JSON.stringify([id]) },
      req
    );
     getAddress = await getAddressDetailsFunction(
      { entityId: JSON.stringify([id]), lang: locale },
      req
    );
     blogTypes = await getvocabTermsObj({ vocabCode: ["blog-types"] ,pageId:1}, req);
     getBlog = await getBlogFunction(
      {
        entityDetailsId: id,
        blogTypeCode: JSON.stringify([
          blogTypes.filter((ele) => ele.code == "about")[0].id,
        ]),
        langId: locale,
      },
      req
    );
  }

 
  if(params.entityType){
    dataOfQuery.slugEntityClassType=[params.entityType]
  }

  dataOfQuery.langCode=locale
  dataOfQuery.slugEntityClass=["entity-details"]
  let getKeywords=await buildQueryForKeywordsFunction(dataOfQuery,req)
  // let Statuscodes={
  //   vocabCode: ["maker-checker-entity-status","maker-checker-status","maker-only-status"]
  // }
  let getTermsByVocab = await getvocabTermsObj(
    { vocabCode: ["days"] },
    req
  );
  let getTerms = await getvocabTermsObj(
    { vocabCode: ["maker-checker-status","maker-checker-entity-status","maker-only-status","entity-categories"] },
    req
  );
  let configStatus=JSON.parse(data.env.approvedStatus)['maker-checker-entity-status'].concat( JSON.parse(data.env.approvedStatus)['maker-checker-status']).concat( JSON.parse(data.env.approvedStatus)['maker-only-status'])

  // const StatusIds = await getIncludeStatusIdsFromBack(Statuscodes,req);
  let statusLst=getTerms.filter(ele=>ele.vocCode=="maker-checker-entity-status"||ele.vocCode=="maker-checker-status"||ele.vocCode=="maker-only-status")
  statusLst=statusLst.filter(ele=>configStatus.includes(ele.code))
  const StatusIds =statusLst.map(ele=>ele.id)
  let entityCategories=getTerms.filter(ele=>ele.vocCode=="entity-categories")
  return {
    props: {
      keyWords:JSON.stringify(getKeywords.content),
      majors: getMajors&&getMajors.data ? JSON.stringify(getMajors.data) : null,
      address:getAddress&& getAddress.content ? JSON.stringify([getAddress.content]) : null,
      blog: getBlog&&getBlog.data ? JSON.stringify(getBlog.data) : null,
      entityDetails: response&&response.data?JSON.stringify(response.data):null,
      statusIds:StatusIds,
   
           days: getTermsByVocab.filter(ele=>ele.vocCode=="days"),
           entityCategories:entityCategories,
           locale:locale,
      params,
      ...(await serverSideTranslations(locale, ["common"]))

    }
  }
};